import { ReactNode, Suspense } from 'react';
import { NARRATIVE_COMMUNITY_LIST_PAGE_SIZE } from '../utils';
import { NarrativeCardLoading } from '@/components/NarrativeCard';

type Props = {
  children: ReactNode;
};

const PLACEHOLDER_ITEMS = new Array(NARRATIVE_COMMUNITY_LIST_PAGE_SIZE).fill(0);

export const NarrativeCommunityListLoader = ({ children }: Props) => {
  return (
    <Suspense
      fallback={
        <section
          className="grid grid-cols-1 md:grid-cols-2 lg: lg:grid-cols-3 gap-x2"
          role="presentation"
          aria-label="Loading skeleton"
        >
          {PLACEHOLDER_ITEMS.map((_, index) => (
            <NarrativeCardLoading showCompanyIcon key={index} />
          ))}
        </section>
      }
    >
      {children}
    </Suspense>
  );
};
